import React, { useState } from 'react';
import InvoiceNumberingSettings from './InvoiceNumberingSettings';
import WFirmaIntegrationSettings from './WFirmaIntegrationSettings';
import CompanyApiKeysSettings from './CompanyApiKeysSettings';
import CompanyUsersTab from './CompanyUsersTab';
import { useTranslation } from '../hooks/useTranslation';

interface CompanySettingsTabProps {
  companyId: string;
}

const CompanySettingsTab: React.FC<CompanySettingsTabProps> = ({ companyId }) => {
  const { t } = useTranslation();
  const [activeSection, setActiveSection] = useState<'numbering' | 'integrations' | 'apiKeys' | 'users'>('numbering');

  const sections = [
    { id: 'numbering' as const, label: t('settings.sections.invoiceNumbering') || 'Нумерация фактур', icon: '🔢' },
    { id: 'integrations' as const, label: t('settings.sections.integrations') || 'Интеграции', icon: '🔌' },
    { id: 'apiKeys' as const, label: t('settings.sections.apiKeys') || 'API keys', icon: '🔑' },
    { id: 'users' as const, label: t('companies.tabs.users') || 'Пользователи', icon: '👤' }
  ];

  return (
    <div className="space-y-6">
      {/* Навигация по секциям */}
      <div className="bg-white rounded-lg shadow">
        <div className="border-b border-gray-200">
          <nav className="flex space-x-8 px-6">
            {sections.map((section) => (
              <button
                key={section.id}
                onClick={() => setActiveSection(section.id)}
                className={`py-4 px-1 border-b-2 font-medium text-sm transition-colors ${
                  activeSection === section.id
                    ? 'border-blue-500 text-blue-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                <span className="mr-2">{section.icon}</span>
                {section.label}
              </button>
            ))}
          </nav>
        </div>
      </div>

      {/* Контент секций */}
      <div className="space-y-6">
        {activeSection === 'numbering' && (
          <InvoiceNumberingSettings companyId={companyId} />
        )}
        
        {activeSection === 'integrations' && (
          <WFirmaIntegrationSettings companyId={companyId} />
        )}

        {activeSection === 'apiKeys' && (
          <CompanyApiKeysSettings companyId={companyId} />
        )}
        
        {activeSection === 'users' && (
          <CompanyUsersTab companyId={companyId} />
        )}
      </div>
    </div>
  );
};

export default CompanySettingsTab;
